var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

(function (aft, $) {
    var widgetWrap = $('#ArticleFullTextWrap');
    var hasAccess = false;

    if (widgetWrap && widgetWrap.attr('data-userHasAccess')) {
        hasAccess = widgetWrap.attr('data-userHasAccess').toLowerCase() === 'true';
    }

    // for un-authenticated users, replace reveal-modal links (such as links to references) with spans
    // since the target of the link is likely to be missing when the user is only viewing an abstract
    aft.replaceContentLinks = function() {
        if (!hasAccess) {
            var contentLinks = widgetWrap.find('a[data-reveal-id]');
            contentLinks.each(function () {
                $(this).replaceWith(function () {
                    var anchorHtml = this.innerHTML;
                    return '<span>' + anchorHtml + '</span>';
                });
            });
        }
    };

    // initialize functionality
    aft.init = function () {
        aft.replaceContentLinks();
        if (SCM.Utilities.Brightcove) {
            SCM.Utilities.Brightcove.init();
        }
        if (SCM.InstitutionOpenUrl) {
            SCM.InstitutionOpenUrl.init();
        }
    };
    insertArticleLinksIntoReferences();
})(SCM.ArticleFulltext = SCM.ArticleFulltext || {}, jQuery);

function insertArticleLinksIntoReferences() {
    var doiRegexPattern = $('#js-hfArticleLinksReferencesDoiRegex').val();
    if (!doiRegexPattern) {
        return;
    }
    
    var doiRegex = new RegExp(doiRegexPattern, 'g');
    var $referenceDois = $('.ref-list').children('div')
        .map(function (index, elem) {
            var elemDois = $(elem).html().match(doiRegex);
            if (!elemDois || !elemDois.length) {
                return null;
            }
            return { 'elem': elem, 'doi': elemDois[0] };
        })
        // Remove empty elements (NOTE:  This is jQuery.filter())
        .filter(function (index, value) { return !!value && !!value.elem && !!value.doi; });
    if (!$referenceDois.length) {
        return;
    }
    var doisToLookup = $referenceDois
        .map(function (index, item) { return item.doi; })
        // Get the underlying array of strings out of the jQuery object
        .get()
        // Filter out duplicates (NOTE: This is Array.filter())
        .filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });


    if (doisToLookup && doisToLookup.length) {
        $.post('/Article/ArticleUrlsByDoi', { 'dois': doisToLookup.toString() }).promise()
            .then(function (result) {
                if (!result || !result.Success) {
                    var d = $.Deferred();
                    d.reject(result.Messages && result.Messages.length
                        ? result.Messages[0]
                        : 'Unknown error');
                    return d;
                }

                $referenceDois.each(function (index, item) {
                    if (item.elem && item.doi && result.Result[item.doi]) {
                        var $firstLink = $(item.elem)
                            .find('.js-ref-link')
                            .first();

                        var $articleLink = $('<div>')
                            .addClass('article-ref-link js-ref-link')
                            .html(
                            $('<a>')
                                .attr('href', result.Result[item.doi])
                                .html('Article')
                            );
                        $firstLink.before($articleLink);
                    }
                });
            })
            .then(null,
            function (err) {
                console.error('Unable to look up resource URLs for DOIs');
                console.error(err);
            });
    }
}